import { RETAIL_KAD_SLIDES, Slide } from '../common';

export const getRetailUpsellSlides = (): Slide[] => {
  return RETAIL_KAD_SLIDES.map(slide => ({
    headline: slide.headline,
    component: slide.component,
  }));
};
